import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { PanelComponent } from '@components/core/panel/panel.component';
import { EvaluationService } from '@services/core/evaluation.service';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { NgSelectComponent } from '@ng-select/ng-select';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { buildYearsBack, periodMonthLabel } from '@shared/period.utils';
import { moduleGroups } from '@shared/module.utils';
import { errorDialog } from '../periods/period-dialogs';
import { asHistoryRows, canLoadHistory, historyErrorText } from './period-history-helpers';

@Component({
  selector: 'app-period-history',
  templateUrl: './period-history.component.html',
  styleUrls: ['./period-history.component.scss'],
  imports: [PanelComponent, FormsModule, NgSelectComponent, DatePipe, NgbTooltipModule],
  providers: [EvaluationService],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: true,
})
export class PeriodHistoryComponent implements OnInit {
  protected module: any;
  protected routeSegment = '';
  protected availableRoutes: string[] = [];
  protected groups: any[] = [];
  protected selectedGroup: any;
  protected years = buildYearsBack(2024);
  protected yearSelected = new Date().getFullYear();
  protected rows: any[] = [];

  private evaluationService = inject(EvaluationService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);

  ngOnInit() {
    const data = this.route.snapshot.data['historyData'] || {};
    this.routeSegment = data.segment ?? (this.route.snapshot.paramMap.get('moduleRoute') || '');
    this.availableRoutes = data.routes || [];
    this.module = data.module;
    this.loadGroups();
  }

  private loadGroups() {
    this.groups = moduleGroups(this.module);
    this.selectedGroup = this.groups[0] || null;
    this.loadHistory();
  }

  onFilterChange() {
    this.loadHistory();
  }

  protected periodLabel(p: any): string {
    return periodMonthLabel(p.period);
  }

  protected viewPeriod(p: any) {
    this.router.navigate([`/${this.routeSegment}/evaluacion`], { queryParams: { periodId: p.id } });
  }

  private loadHistory() {
    if (canLoadHistory(this.module, this.selectedGroup) === false) return;
    this.evaluationService.listPeriodHistory(this.module.id, this.selectedGroup.id, this.yearSelected)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (rows: any[]) => this.onHistoryRows(rows),
        error: (e: any) => this.onHistoryError(e),
      });
  }

  /** Guarda filas normalizadas. */
  private onHistoryRows(rows: any[]) {
    this.rows = asHistoryRows(rows);
  }

  /** Reporta error de historial. */
  private onHistoryError(e: any) {
    console.error('Historial: error cargando datos', e);
    errorDialog(historyErrorText(e));
  }
}
